export function KnowledgeViewSVG() {
  return (
    <svg
      width="380"
      height="170"
      viewBox="0 0 380 170"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4590_58428)">
        <mask id="path-3-inside-1_4590_58428" fill="white">
          <path d="M0 0H274V45H0V0Z" />
        </mask>
        <path d="M0 0H274V45H0V0Z" fill="#F9F9FB" />
        <path
          d="M274 44H0V46H274V44Z"
          fill="#EFF0F3"
          mask="url(#path-3-inside-1_4590_58428)"
        />
        <path
          d="M16.4717 27.5L20.1084 17.6357H21.0518V19.2285H20.6621L17.7637 27.5H16.4717ZM18.1191 24.6768L18.502 23.6309H22.959L23.3418 24.6768H18.1191ZM23.6699 27.5L20.7715 19.2285V17.6357H21.3252L24.9619 27.5H23.6699ZM26.541 27.5V20.1309H27.7305V21.2246H27.8398C27.9811 20.8372 28.2204 20.5365 28.5576 20.3223C28.8949 20.1081 29.3118 20.001 29.8086 20.001C29.9225 20.001 30.0342 20.0078 30.1436 20.0215C30.2575 20.0306 30.3441 20.0397 30.4033 20.0488V21.2041C30.2803 21.1813 30.1595 21.1654 30.041 21.1562C29.9271 21.1426 29.804 21.1357 29.6719 21.1357C29.2936 21.1357 28.9587 21.2109 28.667 21.3613C28.3753 21.5117 28.1452 21.7214 27.9766 21.9902C27.8125 22.2591 27.7305 22.5736 27.7305 22.9336V27.5H26.541ZM34.6279 27.5547C33.8714 27.5547 33.3223 27.402 32.9805 27.0967C32.6432 26.7913 32.4746 26.2878 32.4746 25.5859V21.1152H31.3125V20.1309H32.4746V18.2236H33.7051V20.1309H35.3184V21.1152H33.7051V25.2852C33.7051 25.7181 33.7871 26.0303 33.9512 26.2217C34.1152 26.4085 34.3887 26.502 34.7715 26.502C34.8763 26.502 34.9652 26.4997 35.0381 26.4951C35.1156 26.4906 35.209 26.4837 35.3184 26.4746V27.4863C35.2044 27.5046 35.0905 27.5205 34.9766 27.5342C34.8626 27.5479 34.7464 27.5547 34.6279 27.5547ZM37.123 27.5V20.1309H38.3125V27.5H37.123ZM37.7246 18.709C37.5013 18.709 37.3076 18.6292 37.1436 18.4697C36.984 18.3057 36.9043 18.112 36.9043 17.8887C36.9043 17.6608 36.984 17.4671 37.1436 17.3076C37.3076 17.1481 37.5013 17.0684 37.7246 17.0684C37.9525 17.0684 38.1462 17.1481 38.3057 17.3076C38.4652 17.4671 38.5449 17.6608 38.5449 17.8887C38.5449 18.112 38.4652 18.3057 38.3057 18.4697C38.1462 18.6292 37.9525 18.709 37.7246 18.709ZM43.5693 27.6299C42.8812 27.6299 42.2842 27.4727 41.7783 27.1582C41.2725 26.8438 40.8805 26.3994 40.6025 25.8252C40.3245 25.251 40.1855 24.5742 40.1855 23.7949V23.7812C40.1855 23.0156 40.3223 22.3503 40.5957 21.7852C40.8737 21.2201 41.2656 20.7826 41.7715 20.4727C42.2773 20.1582 42.8743 20.001 43.5625 20.001C44.1595 20.001 44.6745 20.1058 45.1074 20.3154C45.5404 20.5251 45.8867 20.8076 46.1465 21.1631C46.4062 21.514 46.5726 21.9082 46.6455 22.3457L46.6523 22.3867H45.4697L45.4629 22.3662C45.3717 22.0016 45.1644 21.6917 44.8408 21.4365C44.5173 21.1813 44.0911 21.0537 43.5625 21.0537C43.1204 21.0537 42.7376 21.1654 42.4141 21.3887C42.0905 21.612 41.8398 21.9287 41.6621 22.3389C41.4889 22.7445 41.4023 23.2253 41.4023 23.7812V23.7949C41.4023 24.36 41.4912 24.8522 41.6689 25.2715C41.8467 25.6862 42.0973 26.0075 42.4209 26.2354C42.7445 26.4632 43.125 26.5771 43.5625 26.5771C44.0592 26.5771 44.4648 26.4701 44.7793 26.2559C45.0938 26.0417 45.3193 25.7295 45.4561 25.3193L45.4697 25.2783L46.6455 25.2715L46.6318 25.3467C46.5316 25.7887 46.3538 26.1829 46.0986 26.5293C45.8434 26.8711 45.5062 27.14 45.0869 27.3359C44.6676 27.5319 44.1618 27.6299 43.5693 27.6299ZM48.457 27.5V17.2051H49.6465V27.5H48.457ZM54.9375 27.6299C54.2357 27.6299 53.6318 27.4749 53.126 27.165C52.6247 26.8551 52.2373 26.4176 51.9639 25.8525C51.695 25.2829 51.5605 24.613 51.5605 23.8428V23.8359C51.5605 23.0749 51.695 22.4072 51.9639 21.833C52.2373 21.2588 52.6224 20.8099 53.1191 20.4863C53.6159 20.1628 54.1969 20.001 54.8623 20.001C55.5322 20.001 56.1064 20.1559 56.585 20.4658C57.068 20.7757 57.4372 21.2087 57.6924 21.7646C57.9521 22.3161 58.082 22.9587 58.082 23.6924V24.1572H52.1758V23.207H57.4736L56.8857 24.0752V23.6035C56.8857 23.0247 56.7992 22.5485 56.626 22.1748C56.4528 21.8011 56.2135 21.5231 55.9082 21.3408C55.6029 21.154 55.252 21.0605 54.8555 21.0605C54.459 21.0605 54.1035 21.1585 53.7891 21.3545C53.4792 21.5459 53.2331 21.8307 53.0508 22.209C52.8685 22.5872 52.7773 23.0521 52.7773 23.6035V24.0752C52.7773 24.5993 52.8662 25.0482 53.0439 25.4219C53.2217 25.791 53.4746 26.0758 53.8027 26.2764C54.1309 26.4723 54.5182 26.5703 54.9648 26.5703C55.2975 26.5703 55.5869 26.5247 55.833 26.4336C56.0791 26.3424 56.2819 26.2262 56.4414 26.085C56.6009 25.9437 56.7126 25.8001 56.7764 25.6543L56.8037 25.5928H57.9932L57.9795 25.6475C57.9157 25.8981 57.8018 26.1419 57.6377 26.3789C57.4782 26.6113 57.2708 26.8232 57.0156 27.0146C56.7604 27.2015 56.4574 27.3519 56.1064 27.4658C55.7601 27.5752 55.3704 27.6299 54.9375 27.6299Z"
          fill="#60646C"
        />
        <g opacity="0.5" clip-path="url(#clip1_4590_58428)">
          <rect
            width="378"
            height="62"
            transform="translate(0 55)"
            fill="white"
            fill-opacity="0.01"
          />
          <rect
            x="16"
            y="67"
            width="335"
            height="14"
            rx="4"
            fill="url(#paint0_linear_4590_58428)"
            fill-opacity="0.1"
          />
          <rect
            x="16"
            y="91"
            width="123"
            height="14"
            rx="4"
            fill="url(#paint1_linear_4590_58428)"
            fill-opacity="0.1"
          />
        </g>
        <g clip-path="url(#clip2_4590_58428)">
          <rect
            width="378"
            height="38"
            transform="translate(0 127)"
            fill="white"
            fill-opacity="0.01"
          />
          <rect
            x="16"
            y="139"
            width="106"
            height="14"
            rx="4"
            fill="url(#paint2_linear_4590_58428)"
            fill-opacity="0.1"
          />
        </g>
      </g>
      <path
        d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H376C377.933 0.5 379.5 2.067 379.5 4V166C379.5 167.933 377.933 169.5 376 169.5H3.99999C2.067 169.5 0.5 167.933 0.5 166V4Z"
        stroke="#000D37"
        stroke-opacity="0.1624"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4590_58428"
          x1="16"
          y1="81"
          x2="111.17"
          y2="-76.1973"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#3EDDDD" />
          <stop offset="1" stop-color="#F9D40F" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4590_58428"
          x1="16"
          y1="105"
          x2="111.246"
          y2="47.2366"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#3EDDDD" />
          <stop offset="1" stop-color="#F9D40F" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4590_58428"
          x1="16"
          y1="153"
          x2="104.184"
          y2="106.911"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#3EDDDD" />
          <stop offset="1" stop-color="#F9D40F" />
        </linearGradient>
        <clipPath id="clip0_4590_58428">
          <path
            d="M0 4C0 1.79086 1.79086 0 4 0H376C378.209 0 380 1.79086 380 4V166C380 168.209 378.209 170 376 170H3.99999C1.79085 170 0 168.209 0 166V4Z"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_4590_58428">
          <rect
            width="378"
            height="62"
            fill="white"
            transform="translate(0 55)"
          />
        </clipPath>
        <clipPath id="clip2_4590_58428">
          <rect
            width="378"
            height="38"
            fill="white"
            transform="translate(0 127)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function DarkKnowledgeViewSVG() {
  return (
    <svg
      width="380"
      height="170"
      viewBox="0 0 380 170"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_5032_84614)">
        <mask id="path-3-inside-1_5032_84614" fill="white">
          <path d="M0 0H274V45H0V0Z" />
        </mask>
        <path d="M0 0H274V45H0V0Z" fill="#1B1B1F" />
        <path
          d="M274 44H0V46H274V44Z"
          fill="#212225"
          mask="url(#path-3-inside-1_5032_84614)"
        />
        <path
          d="M16.4717 27.5L20.1084 17.6357H21.0518V19.2285H20.6621L17.7637 27.5H16.4717ZM18.1191 24.6768L18.502 23.6309H22.959L23.3418 24.6768H18.1191ZM23.6699 27.5L20.7715 19.2285V17.6357H21.3252L24.9619 27.5H23.6699ZM26.541 27.5V20.1309H27.7305V21.2246H27.8398C27.9811 20.8372 28.2204 20.5365 28.5576 20.3223C28.8949 20.1081 29.3118 20.001 29.8086 20.001C29.9225 20.001 30.0342 20.0078 30.1436 20.0215C30.2575 20.0306 30.3441 20.0397 30.4033 20.0488V21.2041C30.2803 21.1813 30.1595 21.1654 30.041 21.1562C29.9271 21.1426 29.804 21.1357 29.6719 21.1357C29.2936 21.1357 28.9587 21.2109 28.667 21.3613C28.3753 21.5117 28.1452 21.7214 27.9766 21.9902C27.8125 22.2591 27.7305 22.5736 27.7305 22.9336V27.5H26.541ZM34.6279 27.5547C33.8714 27.5547 33.3223 27.402 32.9805 27.0967C32.6432 26.7913 32.4746 26.2878 32.4746 25.5859V21.1152H31.3125V20.1309H32.4746V18.2236H33.7051V20.1309H35.3184V21.1152H33.7051V25.2852C33.7051 25.7181 33.7871 26.0303 33.9512 26.2217C34.1152 26.4085 34.3887 26.502 34.7715 26.502C34.8763 26.502 34.9652 26.4997 35.0381 26.4951C35.1156 26.4906 35.209 26.4837 35.3184 26.4746V27.4863C35.2044 27.5046 35.0905 27.5205 34.9766 27.5342C34.8626 27.5479 34.7464 27.5547 34.6279 27.5547ZM37.123 27.5V20.1309H38.3125V27.5H37.123ZM37.7246 18.709C37.5013 18.709 37.3076 18.6292 37.1436 18.4697C36.984 18.3057 36.9043 18.112 36.9043 17.8887C36.9043 17.6608 36.984 17.4671 37.1436 17.3076C37.3076 17.1481 37.5013 17.0684 37.7246 17.0684C37.9525 17.0684 38.1462 17.1481 38.3057 17.3076C38.4652 17.4671 38.5449 17.6608 38.5449 17.8887C38.5449 18.112 38.4652 18.3057 38.3057 18.4697C38.1462 18.6292 37.9525 18.709 37.7246 18.709ZM43.5693 27.6299C42.8812 27.6299 42.2842 27.4727 41.7783 27.1582C41.2725 26.8438 40.8805 26.3994 40.6025 25.8252C40.3245 25.251 40.1855 24.5742 40.1855 23.7949V23.7812C40.1855 23.0156 40.3223 22.3503 40.5957 21.7852C40.8737 21.2201 41.2656 20.7826 41.7715 20.4727C42.2773 20.1582 42.8743 20.001 43.5625 20.001C44.1595 20.001 44.6745 20.1058 45.1074 20.3154C45.5404 20.5251 45.8867 20.8076 46.1465 21.1631C46.4062 21.514 46.5726 21.9082 46.6455 22.3457L46.6523 22.3867H45.4697L45.4629 22.3662C45.3717 22.0016 45.1644 21.6917 44.8408 21.4365C44.5173 21.1813 44.0911 21.0537 43.5625 21.0537C43.1204 21.0537 42.7376 21.1654 42.4141 21.3887C42.0905 21.612 41.8398 21.9287 41.6621 22.3389C41.4889 22.7445 41.4023 23.2253 41.4023 23.7812V23.7949C41.4023 24.36 41.4912 24.8522 41.6689 25.2715C41.8467 25.6862 42.0973 26.0075 42.4209 26.2354C42.7445 26.4632 43.125 26.5771 43.5625 26.5771C44.0592 26.5771 44.4648 26.4701 44.7793 26.2559C45.0938 26.0417 45.3193 25.7295 45.4561 25.3193L45.4697 25.2783L46.6455 25.2715L46.6318 25.3467C46.5316 25.7887 46.3538 26.1829 46.0986 26.5293C45.8434 26.8711 45.5062 27.14 45.0869 27.3359C44.6676 27.5319 44.1618 27.6299 43.5693 27.6299ZM48.457 27.5V17.2051H49.6465V27.5H48.457ZM54.9375 27.6299C54.2357 27.6299 53.6318 27.4749 53.126 27.165C52.6247 26.8551 52.2373 26.4176 51.9639 25.8525C51.695 25.2829 51.5605 24.613 51.5605 23.8428V23.8359C51.5605 23.0749 51.695 22.4072 51.9639 21.833C52.2373 21.2588 52.6224 20.8099 53.1191 20.4863C53.6159 20.1628 54.1969 20.001 54.8623 20.001C55.5322 20.001 56.1064 20.1559 56.585 20.4658C57.068 20.7757 57.4372 21.2087 57.6924 21.7646C57.9521 22.3161 58.082 22.9587 58.082 23.6924V24.1572H52.1758V23.207H57.4736L56.8857 24.0752V23.6035C56.8857 23.0247 56.7992 22.5485 56.626 22.1748C56.4528 21.8011 56.2135 21.5231 55.9082 21.3408C55.6029 21.154 55.252 21.0605 54.8555 21.0605C54.459 21.0605 54.1035 21.1585 53.7891 21.3545C53.4792 21.5459 53.2331 21.8307 53.0508 22.209C52.8685 22.5872 52.7773 23.0521 52.7773 23.6035V24.0752C52.7773 24.5993 52.8662 25.0482 53.0439 25.4219C53.2217 25.791 53.4746 26.0758 53.8027 26.2764C54.1309 26.4723 54.5182 26.5703 54.9648 26.5703C55.2975 26.5703 55.5869 26.5247 55.833 26.4336C56.0791 26.3424 56.2819 26.2262 56.4414 26.085C56.6009 25.9437 56.7126 25.8001 56.7764 25.6543L56.8037 25.5928H57.9932L57.9795 25.6475C57.9157 25.8981 57.8018 26.1419 57.6377 26.3789C57.4782 26.6113 57.2708 26.8232 57.0156 27.0146C56.7604 27.2015 56.4574 27.3519 56.1064 27.4658C55.7601 27.5752 55.3704 27.6299 54.9375 27.6299Z"
          fill="#ADB1B8"
        />
        <g opacity="0.5" clip-path="url(#clip1_5032_84614)">
          <rect
            width="378"
            height="62"
            transform="translate(0 55)"
            fill="white"
            fill-opacity="0.01"
          />
          <rect
            x="16"
            y="67"
            width="335"
            height="14"
            rx="4"
            fill="url(#paint0_linear_5032_84614)"
            fill-opacity="0.1"
          />
          <rect
            x="16"
            y="91"
            width="123"
            height="14"
            rx="4"
            fill="url(#paint1_linear_5032_84614)"
            fill-opacity="0.1"
          />
        </g>
        <g clip-path="url(#clip2_5032_84614)">
          <rect
            width="378"
            height="38"
            transform="translate(0 127)"
            fill="white"
            fill-opacity="0.01"
          />
          <rect
            x="16"
            y="139"
            width="106"
            height="14"
            rx="4"
            fill="url(#paint2_linear_5032_84614)"
            fill-opacity="0.1"
          />
        </g>
      </g>
      <path
        d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H376C377.933 0.5 379.5 2.067 379.5 4V166C379.5 167.933 377.933 169.5 376 169.5H3.99999C2.067 169.5 0.5 167.933 0.5 166V4Z"
        stroke="#464749"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5032_84614"
          x1="16"
          y1="81"
          x2="111.17"
          y2="-76.1973"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#3EDDDD" />
          <stop offset="1" stop-color="#F9D40F" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5032_84614"
          x1="16"
          y1="105"
          x2="111.246"
          y2="47.2366"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#3EDDDD" />
          <stop offset="1" stop-color="#F9D40F" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_5032_84614"
          x1="16"
          y1="153"
          x2="104.184"
          y2="106.911"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#3EDDDD" />
          <stop offset="1" stop-color="#F9D40F" />
        </linearGradient>
        <clipPath id="clip0_5032_84614">
          <path
            d="M0 4C0 1.79086 1.79086 0 4 0H376C378.209 0 380 1.79086 380 4V166C380 168.209 378.209 170 376 170H3.99999C1.79085 170 0 168.209 0 166V4Z"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_5032_84614">
          <rect
            width="378"
            height="62"
            fill="white"
            transform="translate(0 55)"
          />
        </clipPath>
        <clipPath id="clip2_5032_84614">
          <rect
            width="378"
            height="38"
            fill="white"
            transform="translate(0 127)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
